module.exports = __webpack_public_path__ + "static/twig_blight-1-8dd356629b3368a9c72716c60449d73d.jpg";